import axios from '../../helpers/axios-setup';

export const getClassifications = () => axios.get('/certification-classifications');
